<template>
  <iDropdown
    class="profile-dropdown"
    trigger="click"
    placement="bottom-end"
    @on-click="onSelected">
    <iRow
      class="profile-dropdown-wrapper"
      type="flex"
      justify="end"
      align="middle"
      style="flex-wrap: nowrap;">
      <div class="profile-dropdown-text">
        {{ profile.fullName }}
        <span>{{ profile.employeeNumber }}</span>
      </div>
      <iAvatar
        :src="profile.avatarUrl"
        style="background: #619fe7; margin-left: 10px;"/>
      <iIcon
        class="profile-dropdown-arrow"
        type="arrow-down-b"/>
    </iRow>
    <iDropdownMenu slot="list">
      <iDropdownItem name="dashboard">Dashboard</iDropdownItem>
      <iDropdownItem
        name="logout"
        divided>Logout</iDropdownItem>
    </iDropdownMenu>
  </iDropdown>
</template>

<script>
import AuthService from '@/services/auth';

export default {
  name: 'ProfileMenu',
  props: {
    profile: { type: Object, required: true },
  },
  methods: {
    onSelected(name) {
      if (name === 'logout') this.logout();
    },
    async logout() {
      try {
        await AuthService.logout();
      } finally {
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style>
.profile-dropdown {
  color: white;
  cursor: pointer;
}

.profile-dropdown-wrapper {
  height: 50px;
}
.profile-dropdown-text {
  line-height: 1.1;
  text-align: right;
}
.profile-dropdown-text span {
  display: block;
  font-weight: bold;
  font-size: 10px;
}
.profile-dropdown-arrow {
  margin-left: 8px;
}
</style>
